import React from 'react';
import {Platform, View} from 'react-native';
import { StyleSheet } from 'react-native';

import {ConsultationRequestResBody} from '../../server/types/consultation.types';
import {width, height, totalSize} from 'react-native-dimension';

import ConsultationEnd from '../consultation/ConsultationEnd';

interface ConsultationEndModalProps {
  serviceRequest: ConsultationRequestResBody;
  onCancel?: () => void;
  onComplete?: () => void;
}

const ConsultationEndModal = (props: ConsultationEndModalProps) => {
  

  return (
    <View style={styles.root}>
      <ConsultationEnd
        serviceRequest={props.serviceRequest}
        onCancel={props.onCancel}
        onComplete={props.onComplete}
      />
    </View>
  );
};

const styles = StyleSheet.create(({
  root: {
    width: Platform.OS === 'web' ? 560 : width(90),
    alignContent:'center',
    alignItems:'center',
    justifyContent:'center',
    // paddingVertical: Platform.OS === 'web' ? 24 : 12,
    // paddingHorizontal: Platform.OS === 'web' ? 32 : 20,
  },
}));

export default ConsultationEndModal;
